import React, { FunctionComponent } from 'react';
import { Box, Text } from 'rebass/styled-components';

import { useAppState } from '../../hooks';
import { ConfigEditorType, parseDropdownValue, parseTitle } from './util';
import { ElidableText } from '..';

export interface IEditorDropdownItemProps {
  hasTransfer?: boolean;
  item: any;
  actionType?: ConfigEditorType;
}

const EditorDropdownItem: FunctionComponent<IEditorDropdownItemProps> = ({
  item, hasTransfer = false, actionType,
}: IEditorDropdownItemProps) => {
  const { isCcsV2 } = useAppState();

  return (
    <Box
      pt={1}
      pb={1}
      title={parseTitle(item, actionType)}
      data-testid="editor-dropdown-item"
      sx={{
        cursor: hasTransfer ? 'not-allowed' : '',
      }}
    >
      <ElidableText text={parseDropdownValue(item, actionType, isCcsV2)} lineCount={1} />

      {hasTransfer && (
        <Text variant="info" mt={1}>
          <ElidableText text="(only 1 transfer action allowed per policy)" />
        </Text>
      )}
    </Box>
  );
};

export default EditorDropdownItem;
